import {Component} from '@angular/core';

import {ActivatedRoute, Router} from '@angular/router';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {GeneralListComponent} from '../../general/list/generalList.component';
import {MessageService} from '../../../../shared/message.service';
import {RegoVivoMappingService} from '../../../services/rego-vivo-mapping.service';
import {RegoVivoMapping} from '../../../interfaces/regoVivoMapping';

@Component({
  selector: 'app-regovivomappings',
  templateUrl: '../../general/list/generalList.component.html',
  styleUrls: ['../../general/list/generalList.component.css']
})
export class RegoVivoMappingListComponent extends GeneralListComponent<RegoVivoMapping> {

  constructor(
    service: RegoVivoMappingService,
    router: Router,
    messagesService: MessageService,
    modalService: NgbModal,
    route: ActivatedRoute) {
    super(
      service,
      router,
      messagesService,
      route,
      modalService,
      {
        entityNameSingular: 'rego-vivo mapping',
        entityNamePlural: 'rego-vivo mappings',
        formUrl: 'regovivomapping',
        listUrl: 'regovivomappings',
        generalFormMetaName: 'rego-vivo-mapping'
      },
    );
  }
}
